// import { useState } from 'react'
// import { useNavigate, useParams } from 'react-router-dom'
// import { Container, Form, Button, Card } from 'react-bootstrap'
// import { PlayBtn, ListCheck } from 'react-bootstrap-icons'
// import { Link } from 'react-router-dom'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import Header from '../Components/Header'

// export default function CreateCoursePage() {
//   const { id } = useParams()
//   const [step, setStep] = useState(1)
//   const [courseData, setCourseData] = useState({
//     type: null,
//     title: '',
//     category: '',
//     timeCommitment: '',
//     price: '',
//     description: '',
//   })

//   const [loading, setLoading] = useState(false)
//   const [error, setError] = useState(null)
//   const navigate = useNavigate()
//   const token = localStorage.getItem('jwttoken')

//   const categories = [
//     'Development',
//     'Business',
//     'Finance & Accounting',
//     'IT & Software',
//     'Office Productivity',
//     'Personal Development',
//     'Design',
//     'Marketing',
//     'Lifestyle',
//     'Photography & Video',
//     'Health & Fitness',
//     'Music',
//     'Teaching & Academics',
//   ]

//   const timeOptions = [
//     { id: 'busy', label: "I'm very busy right now (0-2 hours)", value: '0-2' },
//     {
//       id: 'side',
//       label: "I'll work on this on the side (2-4 hours)",
//       value: '2-4',
//     },
//     {
//       id: 'flexible',
//       label: 'I have lots of flexibility (5+ hours)',
//       value: '5+',
//     },
//     {
//       id: 'undecided',
//       label: "I haven't yet decided if I have time",
//       value: 'undecided',
//     },
//   ]

//   const handleSubmit = async (e) => {
//     e.preventDefault()

//     if (step < 4) {
//       setStep(step + 1)
//     } else {
//       setLoading(true)
//       setError(null)

//       const today = new Date().toISOString().split('T')[0]

//       const payload = {
//         title: courseData.title || null,
//         categories: courseData.category ? [courseData.category] : [],
//         time_commitment: courseData.timeCommitment || null,
//         start_date: today,
//         price: courseData.price || null,
//         description: courseData.description || null,
//         trailer: null,
//         cover_img: null,
//       }

//       try {
//         const response = await fetch('https://kaasbackend.vetrinahealthcare.com/lms/courses/', {
//           method: 'PUT',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify(payload),
//         })

//         if (!response.ok) {
//           if (response.status === 401) {
//             throw new Error('Unauthorized! Please log in again.')
//           }
//           throw new Error('Failed to create course. Please try again.')
//         }

//         const result = await response.json()
//         console.log('Course created:', result)

//         if (result.course_id) {
//           localStorage.setItem('createdCourseId', result.course_id)
//           console.log('Stored Course ID:', result.course_id)
//           navigate(`/addcourseinfo/${result.course_id}`)
//         } else {
//           console.error('Course ID not found in response.')
//         }
//       } catch (err) {
//         setError(err.message)
//       } finally {
//         setLoading(false)
//       }
//     }
//   }

//   const renderStepContent = () => {
//     switch (step) {
//       case 1:
//         return (
//           <>
//             <h1 className='text-center display-5 fw-bold mb-3'>
//               First, let&apos;s find out what type of course you&apos;re making.
//             </h1>
//             <div className='row g-4'>
//               <div className='col-md-6'>
//                 <Card
//                   className='h-100 p-4 cursor-pointer'
//                   onClick={() =>
//                     setCourseData({ ...courseData, type: 'course' })
//                   }
//                   style={{
//                     cursor: 'pointer',
//                     borderColor: courseData.type === 'course' ? '#9333ea' : '',
//                     borderWidth: courseData.type === 'course' ? '2px' : '1px',
//                   }}
//                 >
//                   <Card.Body className='d-flex flex-column align-items-center text-center gap-3'>
//                     <PlayBtn className='fs-1 text-secondary' />
//                     <h2 className='fs-4 fw-semibold'>Course</h2>
//                     <p className='text-muted'>
//                       Create rich learning experiences with videos, quizzes, and
//                       exercises.
//                     </p>
//                   </Card.Body>
//                 </Card>
//               </div>
//               <div className='col-md-6'>
//                 <Card
//                   className='h-100 p-4 cursor-pointer'
//                   onClick={() =>
//                     setCourseData({ ...courseData, type: 'practice-test' })
//                   }
//                   style={{
//                     cursor: 'pointer',
//                     borderColor:
//                       courseData.type === 'practice-test' ? '#9333ea' : '',
//                     borderWidth:
//                       courseData.type === 'practice-test' ? '2px' : '1px',
//                   }}
//                 >
//                   <Card.Body className='d-flex flex-column align-items-center text-center gap-3'>
//                     <ListCheck className='fs-1 text-secondary' />
//                     <h2 className='fs-4 fw-semibold'>Practice Test</h2>
//                     <p className='text-muted'>
//                       Help students prepare for certification exams with
//                       practice questions.
//                     </p>
//                   </Card.Body>
//                 </Card>
//               </div>
//             </div>
//           </>
//         )
//       case 2:
//         return (
//           <>
//             <h1 className='text-center display-5 fw-bold mb-3'>
//               How about a working title?
//             </h1>
//             <Form.Control
//               type='text'
//               placeholder='e.g. Learn Photoshop CS6 from Scratch'
//               value={courseData.title}
//               onChange={(e) =>
//                 setCourseData({ ...courseData, title: e.target.value })
//               }
//               maxLength={60}
//               className='form-control-lg'
//             />
//           </>
//         )
//       case 3:
//         return (
//           <>
//             <h1 className='text-center display-5 fw-bold mb-3'>
//               What category best fits the knowledge you&apos;ll share?
//             </h1>
//             <Form.Select
//               size='lg'
//               value={courseData.category}
//               onChange={(e) =>
//                 setCourseData({ ...courseData, category: e.target.value })
//               }
//               className='mb-4'
//             >
//               <option value=''>Choose a category</option>
//               {categories.map((cat) => (
//                 <option key={cat} value={cat}>
//                   {cat}
//                 </option>
//               ))}
//             </Form.Select>
//             <Form.Control
//               type='number'
//               placeholder='Enter Price'
//               value={courseData.price}
//               onChange={(e) =>
//                 setCourseData({ ...courseData, price: e.target.value })
//               }
//               className='mb-3'
//             />
//           </>
//         )
//       case 4:
//         return (
//           <>
//             <h1 className='text-center display-5 fw-bold mb-4'>
//               How much time can you spend creating your course per week?
//             </h1>
//             {timeOptions.map((option) => (
//               <div
//                 key={option.id}
//                 className='border rounded p-3 cursor-pointer mb-2'
//                 onClick={() =>
//                   setCourseData({ ...courseData, timeCommitment: option.value })
//                 }
//                 style={{
//                   cursor: 'pointer',
//                   backgroundColor:
//                     courseData.timeCommitment === option.value
//                       ? '#f8f9fa'
//                       : 'white',
//                 }}
//               >
//                 <Form.Check
//                   type='radio'
//                   id={option.id}
//                   label={option.label}
//                   name='timeCommitment'
//                   checked={courseData.timeCommitment === option.value}
//                   onChange={() =>
//                     setCourseData({
//                       ...courseData,
//                       timeCommitment: option.value,
//                     })
//                   }
//                   className='m-0'
//                 />
//               </div>
//             ))}
//           </>
//         )
//       default:
//         return null
//     }
//   }

//   return (
//     <div className='min-vh-100 bg-white'>
//       <Header />
//       <header className='border-bottom'>
//         <Container
//           className='d-flex align-items-center justify-content-between'
//           style={{ height: '64px', marginTop: '4.5rem' }}
//         >
//           <span className='fw-semibold'>Step {step} of 4</span>
//           <Link
//             to='/course/create'
//             className='text-decoration-none'
//             style={{ color: '#9333ea' }}
//           >
//             Back
//           </Link>
//         </Container>
//       </header>
//       <Container className='py-5'>
//         {error && <p className='text-danger'>{error}</p>}
//         <Form onSubmit={handleSubmit}>
//           {renderStepContent()}
//           <div className='d-flex justify-content-between mt-4'>
//             {step > 1 && (
//               <Button
//                 variant='outline-secondary'
//                 onClick={() => setStep(step - 1)}
//               >
//                 Back
//               </Button>
//             )}
//             <Button type='submit' variant='primary' disabled={loading}>
//               {loading ? 'Submitting...' : step < 4 ? 'Next' : 'Submit'}
//             </Button>
//           </div>
//         </Form>
//       </Container>
//     </div>
//   )
// }

import { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import { Container, Form, Button, Card, Spinner, Alert } from 'react-bootstrap'
import { PlayBtn, ListCheck } from 'react-bootstrap-icons'
import 'bootstrap/dist/css/bootstrap.min.css'
import Header from '../Components/Header'

const VETRINA_ORANGE = '#FF7A00'
const VETRINA_PURPLE = '#9333EA'

export default function CreateCoursePage() {
  const { id } = useParams()
  const [step, setStep] = useState(1)
  const [courseData, setCourseData] = useState({
    type: null,
    title: '',
    category: '',
    timeCommitment: '',
    price: '',
    priceType: null, // 'free' or 'paid'
  })

  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const navigate = useNavigate()
  const token = localStorage.getItem('jwttoken')

  const timeOptions = [
    { id: 'busy', label: "I'm very busy right now (0-2 hours)", value: '0-2' },
    { id: 'side', label: "I'll work on this on the side (2-4 hours)", value: '2-4' },
    { id: 'flexible', label: 'I have lots of flexibility (5+ hours)', value: '5+' },
    { id: 'undecided', label: "I haven't yet decided if I have time", value: 'undecided' },
  ]

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          'https://kaasbackend.vetrinahealthcare.com/lms/categories/',
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )

        if (!response.ok) {
          throw new Error('Failed to fetch categories')
        }

        const data = await response.json()
        setCategories(data)
      } catch (err) {
        console.error(err)
        setError('Failed to load categories.')
      }
    }

    fetchCategories()
  }, [token])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (step < 4) {
      setStep(step + 1)
    } else {
      setLoading(true)
      setError(null)

      const today = new Date().toISOString().split('T')[0]

      const payload = {
        title: courseData.title,
        categories: [courseData.category],
        time_commitment: courseData.timeCommitment,
        start_date: today,
        price: courseData.price, // This is now '0' for free or the entered value for paid
      }

      try {
        const response = await fetch(
          'https://kaasbackend.vetrinahealthcare.com/lms/courses/',
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          }
        )

        if (!response.ok) {
          if (response.status === 401) {
            throw new Error('Unauthorized! Please log in again.')
          }
          throw new Error('Failed to create course. Please try again.')
        }

        const result = await response.json()
        if (result.course_id) {
          localStorage.setItem('createdCourseId', result.course_id)
          navigate(`/addcourseinfo/${result.course_id}`)
        } else {
          console.error('Course ID not found in response.')
        }
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }
  }

  const isStepValid = () => {
    switch (step) {
      case 1:
        return !!courseData.type
      case 2:
        return courseData.title.trim().length > 0
      case 3:
        const isCategorySelected = !!courseData.category
        const isPriceValid =
          courseData.priceType === 'free' ||
          (courseData.priceType === 'paid' && Number(courseData.price) > 0)
        return isCategorySelected && isPriceValid
      case 4:
        return !!courseData.timeCommitment
      default:
        return false
    }
  }

  const renderStepContent = () => {
    switch (step) {
      case 1:
        // This step remains unchanged
        return (
            <>
              <h1
                className='text-center display-5 fw-bold mb-4'
                style={{
                  background: `linear-gradient(90deg, ${VETRINA_ORANGE} 0%, ${VETRINA_PURPLE} 100%)`,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Choose your course type
              </h1>
              <div className='row g-4'>
                <div className='col-md-6'>
                  <Card
                    className={`h-100 p-4 shadow-sm ${
                      courseData.type === 'course' ? 'border border-3' : 'border'
                    }`}
                    onClick={() => setCourseData({ ...courseData, type: 'course' })}
                    style={{
                      cursor: 'pointer',
                      borderColor:
                        courseData.type === 'course' ? VETRINA_PURPLE : '#dee2e6',
                      transition: 'transform 0.2s, border 0.2s',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                  >
                    <Card.Body className='d-flex flex-column align-items-center text-center gap-3'>
                      <PlayBtn className='fs-1' style={{ color: "orange" }} />
                      <h2 className='fs-4 fw-semibold'>Course</h2>
                      <p className='text-muted'>
                        Create lessons with videos, quizzes, and more.
                      </p>
                    </Card.Body>
                  </Card>
                </div>
                <div className='col-md-6'>
                  <Card
                    className={`h-100 p-4 shadow-sm ${
                      courseData.type === 'practice-test' ? 'border border-3' : 'border'
                    }`}
                    onClick={() => setCourseData({ ...courseData, type: 'practice-test' })}
                    style={{
                      cursor: 'pointer',
                      borderColor:
                        courseData.type === 'practice-test' ? VETRINA_PURPLE : '#dee2e6',
                      transition: 'transform 0.2s, border 0.2s',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                  >
                    <Card.Body className='d-flex flex-column align-items-center text-center gap-3'>
                      <ListCheck className='fs-1' style={{ color: VETRINA_PURPLE }} />
                      <h2 className='fs-4 fw-semibold'>Practice Test</h2>
                      <p className='text-muted'>
                        Create quizzes to test students for certifications.
                      </p>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </>
          )
      case 2:
        // This step remains unchanged
        return (
            <>
              <h1 className='text-center display-5 fw-bold mb-4'>
                Name your course
              </h1>
              <Form.Control
                type='text'
                placeholder='Title of your Course'
                value={courseData.title}
                onChange={(e) => setCourseData({ ...courseData, title: e.target.value })}
                maxLength={60}
                className='form-control-lg shadow-sm'
              />
            </>
          )
      case 3:
        return (
          <>
            <h1 className='text-center display-5 fw-bold mb-4'>
              Pick the best category & price
            </h1>
            <Form.Select
              size='lg'
              value={courseData.category}
              onChange={(e) =>
                setCourseData({ ...courseData, category: e.target.value })
              }
              className='mb-4 shadow-sm'
            >
              <option value=''>Choose a category</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.name}>
                  {cat.name}
                </option>
              ))}
            </Form.Select>
            
            {/* New Price Type Selection */}
            <div className='mb-4 text-center p-3 bg-light rounded'>
              <Form.Check
                inline
                type="radio"
                label="Free"
                name="priceType"
                id="price-free"
                checked={courseData.priceType === 'free'}
                onChange={() => setCourseData({ ...courseData, priceType: 'free', price: '0' })}
                className='fs-5 me-5'
              />
              <Form.Check
                inline
                type="radio"
                label="Paid"
                name="priceType"
                id="price-paid"
                checked={courseData.priceType === 'paid'}
                // If switching from free to paid, clear the price so the user must enter one
                onChange={() => setCourseData({ ...courseData, priceType: 'paid', price: courseData.price === '0' ? '' : courseData.price })}
                className='fs-5'
              />
            </div>

            {/* Conditional Price Input for "Paid" courses */}
            {courseData.priceType === 'paid' && (
              <Form.Control
                type='number'
                placeholder='Enter Price (₹)'
                min='1'
                value={courseData.price}
                onChange={(e) =>
                  setCourseData({
                    ...courseData,
                    // Ensure value is not negative, but allow empty string to clear the field.
                    price: e.target.value ? Math.max(1, parseInt(e.target.value, 10)) : '',
                  })
                }
                className='mb-3 form-control-lg shadow-sm'
                required
              />
            )}
          </>
        )
      case 4:
        // This step remains unchanged
        return (
          <>
            <h1 className='text-center display-5 fw-bold mb-4'>
              Weekly time commitment?
            </h1>
            {timeOptions.map((option) => (
              <div
                key={option.id}
                className={`border rounded p-3 mb-2 shadow-sm ${
                  courseData.timeCommitment === option.value ? 'bg-light' : 'bg-white'
                }`}
                onClick={() =>
                  setCourseData({ ...courseData, timeCommitment: option.value })
                }
                style={{ cursor: 'pointer', transition: 'background 0.3s' }}
              >
                <Form.Check
                  type='radio'
                  id={option.id}
                  label={option.label}
                  name='timeCommitment'
                  checked={courseData.timeCommitment === option.value}
                  onChange={() =>
                    setCourseData({ ...courseData, timeCommitment: option.value })
                  }
                  className='m-0'
                />
              </div>
            ))}
          </>
        )
      default:
        return null
    }
  }

  return (
    <div className='min-vh-100 bg-white'>
      <Header />
      <header className='border-bottom bg-light'>
        <Container
          className='d-flex align-items-center justify-content-between'
          style={{ height: '64px', marginTop: '4.5rem' }}
        >
          <span className='fw-semibold text-muted'>Step {step} of 4</span>
          <Link to='/course/create' className='text-decoration-none' style={{ color: VETRINA_PURPLE }}>
            Back
          </Link>
        </Container>
      </header>
      <Container className='py-5' style={{ maxWidth: '720px' }}>
        {error && <Alert variant='danger'>{error}</Alert>}
        <Form onSubmit={handleSubmit} className='p-4 rounded bg-white shadow-sm'>
          {renderStepContent()}
          <div className='d-flex justify-content-between mt-4'>
            {step > 1 && (
              <Button
                variant='outline-secondary'
                onClick={() => setStep(step - 1)}
                className='px-4 py-2'
                style={{ borderColor: VETRINA_PURPLE, color: VETRINA_PURPLE }}
              >
                Back
              </Button>
            )}
            <Button
              type='submit'
              style={{
                backgroundColor: VETRINA_ORANGE,
                border: 'none',
              }}
              className='px-4 py-2'
              disabled={!isStepValid() || loading}
            >
              {loading ? (
                <>
                  <Spinner animation='border' size='sm' className='me-2' /> Saving...
                </>
              ) : step < 4 ? (
                'Next'
              ) : (
                'Submit'
              )}
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  )
}